import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import '../../scss/components/_proposalNavigation.scss';

export function ProposalReturnBridge() {
  const auth = useSelector((state) => state.auth || {});
  const navigate = useNavigate();
  useEffect(() => {
    if (!auth.authenticate) return;
    const target = sessionStorage.getItem('alotbProposalReturn');
    if (target && /^\/order-proposals(?:\/|\?|$)/.test(target)) {
      sessionStorage.removeItem('alotbProposalReturn');
      navigate(target);
    }
  }, [auth.authenticate, navigate]);
  return null;
}

export function ProposalInboxEntry() {
  return <aside className="proposal-inbox-entry"><Link className="proposal-inbox-entry__link" to="/order-proposals">Предложения и цифровые заказы →</Link></aside>;
}
